import React, { useEffect, useState } from 'react'
import { useLanguage } from '../../Providers/LanguageContext';
import { useUserData } from '../../Providers/UserWrapper';
import HttpClient from '../../utils/HttpClient';
import moment from 'moment';
import PaginationReport from './PaginationReport'

const BudgetProfitTable = ({ reportDate }) => {
    const { language, currentLanguage } = useLanguage();
    const { isBusiness, setProfitCsv, setProfitExcel, profileData } = useUserData();

    const [yearData, setYearData] = useState([])
    const [monthData, setMonthData] = useState([])
    const [weekData, setWeekData] = useState([])
    const [dayData, setDayData] = useState([])

    const [pagiDayData, setPagiDayData] = useState([]);
    const [pagiWeekData, setPagiWeekData] = useState([]);
    const [pagiMonthData, setPagimonthData] = useState([]);
    const [pagiYearData, setPagiYearData] = useState([]);

    console.log('yearDataPro', yearData)


    const getYearData = async () => {
        const res = await HttpClient.requestData("self-service-profit-yearly", "GET", {});
        // console.log('yearDatarev', res);
        if (res && res?.status) {
            setYearData(res?.data)
        }
    }

    const getMonthData = async () => {
        const res = await HttpClient.requestData("self-service-profit-monthly", "GET", {});
        console.log('SelfMonthRes', res);
        if (res && res?.status) {
            setMonthData(res?.data)
        }
    }

    const getWeekData = async () => {
        const res = await HttpClient.requestData("self-service-profit-weekly", "GET", {});
        console.log('selfWeekRes', res);
        if (res && res?.status) {
            setWeekData(res?.data);
        }
    }

    const getDayData = async () => {
        console.log('reportDateRev', reportDate)
        if (reportDate.startData && reportDate.endDate) {
            const res = await HttpClient.requestData("self-service-profit-date", "POST", reportDate);
            console.log('selfDayaData', res);
            if (res && res?.status) {
                setDayData(res?.data)
            }
        } else {
            const res = await HttpClient.requestData("self-service-profit-daily", "GET", {});
            console.log('selfDayaData', res);
            if (res && res?.status) {
                setDayData(res?.data)
            }
        }
    }

    useEffect(() => {
        getYearData();
        getMonthData();
        getWeekData();
    }, [])

    useEffect(() => {
        getDayData();
    }, [reportDate]);

    const getMonthName = (num) => {
        console.log('monthDataNum', num)
        switch (num) {
            case 1: return language.january;
            case 2: return language.february;
            case 3: return language.march;
            case 4: return language.april;
            case 5: return language.may;
            case 6: return language.june;
            case 7: return language.july;
            case 8: return language.august;
            case 9: return language.september;
            case 10: return language.october;
            case 11: return language.november;
            case 12: return language.december;
        }
    }

    useEffect(() => {

        const maxLength = Math.max(yearData.length, monthData.length, weekData.length, dayData.length)
        console.log('maxLength', maxLength)

        // header
        let revenueHeader = [
            { label: "", key: "titles" },
        ];
        for (let i = 0; i < maxLength; i++) {
            revenueHeader = [
                ...revenueHeader,
                { label: "", key: String(i) },
            ]
        }
        console.log('revenueHeader', revenueHeader)

        // data
        // day
        let obj1 = { titles: "Day" };
        let obj2 = { titles: "Daily Profit – Budget $ Amount" };
        let obj3 = { titles: "Daily Profit – Budget $ Amount" };
        let obj4 = { titles: "Daily Profit Budget Performance +/-" };

        let revenueData = []
        if (dayData.length) {
            dayData.forEach((item, i) => {
                obj1 = { ...obj1, [i]: moment(item._id).format("YYYY-MM-DD") };
                obj2 = { ...obj2, [i]: item.actualProfit };
                obj3 = { ...obj3, [i]: item.budgetProfit };
                obj4 = { ...obj4, [i]: item.profitBudgetperformance };
            })
            revenueData = [obj1, obj2, obj3, obj4]
        }

        // week
        let objWeek = { titles: "" };
        let obj5 = { titles: "Week" };
        let obj6 = { titles: "Daily Profit – Budget $ Amount" };
        let obj7 = { titles: "Daily Profit – Budget $ Amount" };
        let obj8 = { titles: "Daily Profit Budget Performance +/-" };

        if (weekData.length) {
            weekData.forEach((item, i) => {
                obj5 = { ...obj5, [i]: "week " + item._id };
                obj6 = { ...obj6, [i]: item.actualProfit };
                obj7 = { ...obj7, [i]: item.budgetProfit };
                obj8 = { ...obj8, [i]: item.profitBudgetperformance };
            })
            revenueData = [...revenueData, objWeek, obj5, obj6, obj7, obj8]
        }

        // month
        let objMonth = { titles: "" };
        let obj9 = { titles: "Month" };
        let obj10 = { titles: "Monthly Profit – Actual $ Amount	" };
        let obj11 = { titles: "Monthly Profit – Budget $ Amount	" };
        let obj12 = { titles: "Monthly Profit Budget Performance +/-" };

        if (monthData.length) {
            monthData.forEach((item, i) => {
                obj9 = { ...obj9, [i]: getMonthName(item._id) };
                obj10 = { ...obj10, [i]: item.actualProfit };
                obj11 = { ...obj11, [i]: item.budgetProfit };
                obj12 = { ...obj12, [i]: item.profitBudgetperformance };
            })
            revenueData = [...revenueData, objMonth, obj9, obj10, obj11, obj12]
        }

        // Year
        let objYear = { titles: "" };
        let obj13 = { titles: "Year" };
        let obj14 = { titles: "Yearly Profit – Actual $ Amount	" };
        let obj15 = { titles: "Yearly Profit – Budget $ Amount	" };
        let obj16 = { titles: "Yearly Profit Budget Performance +/-" };

        if (yearData.length) {
            yearData.forEach((item, i) => {
                obj13 = { ...obj13, [i]: item.year };
                obj14 = { ...obj14, [i]: item.actualprofit };
                obj15 = { ...obj15, [i]: item.budgetProfit };
                obj16 = { ...obj16, [i]: item.budgetPerformance };
            })
            revenueData = [...revenueData, objYear, obj13, obj14, obj15, obj16];
        }

        console.log('revenueData', revenueData)

        setProfitCsv({
            headers: revenueHeader,
            data: revenueData
        });

        getExcelData();
    }, [yearData, monthData, weekData, dayData, currentLanguage]);

    const getExcelData = () => {
        let myArray = [
            [language.report_generated_by, profileData?.name + " " + profileData?.surName],
            [language.report_generated_on, moment().format("YYYY-MM-DD")],
            [],
            [language.act_budget_profit]
        ];

        // day
        let arr1 = [language.daily];
        let arr2 = [isBusiness ? language.daily_profit_act_amt : language.daily_margin_act_amt];
        let arr3 = [isBusiness ? language.daily_profit_budget_amt : language.daily_margin_budget_amt];
        let arr4 = [isBusiness ? language.daily_profit_budget_perf : language.daily_margin_budget_perf];
        dayData.forEach((item) => {
            arr1.push(moment(item._id).format("YYYY-MM-DD"));
            arr2.push(item.actualProfit);
            arr3.push(item.budgetProfit);
            arr4.push(item.profitBudgetperformance);
        })

        // week
        let arr5 = [language.weekly];
        let arr6 = [isBusiness ? language.weekly_profit_act_amt : language.weekly_margin_act_amt];
        let arr7 = [isBusiness ? language.weekly_profit_budget_amt : language.weekly_margin_budget_amt];
        let arr8 = [isBusiness ? language.weekly_profit_budget_perf : language.weekly_margin_budget_perf];
        weekData.forEach((item) => {
            arr5.push(language.week + " " + item._id);
            arr6.push(item.actualProfit);
            arr7.push(item.budgetProfit);
            arr8.push(item.profitBudgetperformance);
        })

        // month
        let arr9 = [language.monthly];
        let arr10 = [isBusiness ? language.monthly_profit_act_amt : language.monthly_margin_act_amt];
        let arr11 = [isBusiness ? language.monthly_profit_budget_amt : language.monthly_margin_budget_amt];
        let arr12 = [isBusiness ? language.monthly_profit_budget_perf : language.monthly_margin_budget_perf];
        monthData.forEach((item) => {
            arr9.push(getMonthName(item._id));
            arr10.push(item.actualProfit);
            arr11.push(item.budgetProfit);
            arr12.push(item.profitBudgetperformance);
        })

        // year
        let arr13 = [language.yearly];
        let arr14 = [isBusiness ? language.yearly_profit_act_amt : language.yearly_margin_act_amt];
        let arr15 = [isBusiness ? language.yearly_profit_budget_amt : language.monthly_margin_budget_amt];
        let arr16 = [isBusiness ? language.yearly_profit_budget_perf : language.monthly_margin_budget_perf];
        yearData.forEach((item) => {
            arr13.push(item.year);
            arr14.push(item.actualprofit);
            arr15.push(item.budgetProfit);
            arr16.push(item.budgetPerformance);
        })

        myArray = [...myArray, arr1, arr2, arr3, arr4, [], arr5, arr6, arr7, arr8, [], arr9, arr10, arr11, arr12, [], arr13, arr14, arr15, arr16];

        console.log('myArray', myArray)

        setProfitExcel(myArray);
    }


    return (
        <div>
            {/* Daily */}
            <h4 className="mt-4">{language.daily}</h4>
            <div className='table-responsive'>
                <table className="table table-striped gen-fin-table">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            {
                                pagiDayData.length
                                    ?
                                    pagiDayData.map((item, i) =>
                                        <th scope="col" key={i}>{moment(item._id).format("YYYY-MM-DD")}</th>
                                    )
                                    :
                                    // language.no_data
                                    ""
                            }
                        </tr>
                    </thead>
                    <tbody className="">
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.daily_profit_act_amt : language.daily_margin_act_amt}
                            </td>
                            {
                                pagiDayData.length
                                    ?
                                    pagiDayData.map((item, i) =>
                                        <td key={i}>{item.actualProfit.toFixed(2)}</td>
                                    )
                                    :
                                    "-"
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.daily_profit_budget_amt : language.daily_margin_budget_amt}
                            </td>
                            {
                                pagiDayData.length
                                    ?
                                    pagiDayData.map((item, i) =>
                                        <td key={i}>{item.budgetProfit.toFixed(2)}</td>
                                    )
                                    :
                                    "-"
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.daily_profit_budget_perf : language.daily_margin_budget_perf}
                            </td>
                            {
                                pagiDayData.length
                                    ?
                                    pagiDayData.map((item, i) =>
                                        <td key={i}>{item.profitBudgetperformance.toFixed(2)}</td>
                                    )
                                    :
                                    "-"
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
            <PaginationReport
                originalData={dayData}
                setPaginateData={setPagiDayData}
            />

            {/* Weekly */}
            <h4 className="mt-4">{language.weekly}</h4>
            <div className="table-responsive">
                <table className="table table-striped gen-fin-table">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            {
                                pagiWeekData.length && pagiWeekData.map((item, i) =>
                                    <th scope="col" key={i}>{language.week} {item._id}</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody className="">
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.weekly_profit_act_amt : language.weekly_margin_act_amt}
                            </td>
                            {
                                pagiWeekData.length && pagiWeekData.map((item, i) =>
                                    <td key={i}>{item.actualProfit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.weekly_profit_budget_amt : language.weekly_margin_budget_amt}
                            </td>
                            {
                                pagiWeekData.length && pagiWeekData.map((item, i) =>
                                    <td key={i}>{item.budgetProfit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.weekly_profit_budget_perf : language.weekly_margin_budget_perf}
                            </td>
                            {
                                pagiWeekData.length && pagiWeekData.map((item, i) =>
                                    <td key={i}>{item.profitBudgetperformance.toFixed(2)}</td>
                                )
                            }
                        </tr>
                    </tbody>

                </table>
            </div>
            <PaginationReport
                originalData={weekData}
                setPaginateData={setPagiWeekData}
            />


            {/* Monthly */}
            <h4 className="mt-4">{language.monthly}</h4>
            <div className='table-responsive'>
                <table className="table table-striped gen-fin-table">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            {
                                pagiMonthData.map((item, i) =>
                                    <th scope="col" key={i}>{getMonthName(item._id)}</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody className="">
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.monthly_profit_act_amt : language.monthly_margin_act_amt}
                            </td>
                            {
                                pagiMonthData.map((item, i) =>
                                    <td key={i}>{item.actualProfit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.monthly_profit_budget_amt : language.monthly_margin_budget_amt}
                            </td>
                            {
                                pagiMonthData.map((item, i) =>
                                    <td key={i}>{item.budgetProfit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.monthly_profit_budget_perf : language.monthly_margin_budget_perf}
                            </td>
                            {
                                pagiMonthData.map((item, i) =>
                                    <td key={i}>{item.profitBudgetperformance.toFixed(2)}</td>
                                )
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
            <PaginationReport
                originalData={monthData}
                setPaginateData={setPagimonthData}
            />

            {/* Yearly */}
            <h4 className="mt-4">{language.yearly}</h4>
            <div className='table-responsive'>
                <table className="table table-striped gen-fin-table">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            {
                                pagiYearData.map((item, i) =>
                                    <th scope="col" key={i}>{item.year}</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody className="">
                        <tr>
                            <td className='report-first-column'>
                                {isBusiness ? language.yearly_profit_act_amt : language.yearly_margin_act_amt}
                            </td>
                            {
                                pagiYearData.map((item, i) =>
                                    <td>{item.actualprofit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>{isBusiness ? language.yearly_profit_budget_amt : language.yearly_margin_budget_amt}</td>
                            {
                                pagiYearData.map((item, i) =>
                                    <td>{item.budgetProfit.toFixed(2)}</td>
                                )
                            }
                        </tr>
                        <tr>
                            <td className='report-first-column'>{isBusiness ? language.yearly_profit_budget_perf : language.yearly_margin_budget_perf}</td>
                            {
                                pagiYearData.map((item, i) =>
                                    <td>{item.budgetPerformance.toFixed(2)}</td>
                                )
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
            <PaginationReport
                originalData={yearData}
                setPaginateData={setPagiYearData}
            />
        </div>

    )
}

export default BudgetProfitTable;